module.exports = __webpack_public_path__ + "img/cy.0e73089b.jpg";